export const iconFontAwesomeHumanitarianTentArrowTurnLeft = (
	<i className="fa-solid fa-tent-arrow-turn-left"></i>
);
